import React, { useEffect, useState } from 'react'
import Button from '../../../../../components/ui/buttons/Button'
import { fetchWithCsrf } from '../../../../../utils/fetchWithCsrf'
import { snakecaseKeys } from '../../../../../utils/snakecaseKeys'
import { camelizeKeys } from '../../../../../utils/camelizeKeys'
import CurrencyInput from '../../../../../components/ui/inputs/CurrencyInput'
import ObjectiveFormList from '../../../../../components/forms/profileObjective/ObjectiveFormList'
import { useToast } from '../../../../../components/ui/toast/ToastContext'
import { formatCurrency } from '../../../../../utils/formatters'

const ObjectivesTab = ({ clientId, onSuccess, canWrite }) => {
  const [form, setForm] = useState({
    objectivesAttributes: [],
  })

  const [saving, setSaving] = useState(false)
  const { addToast } = useToast()

  const fetchData = () => {
    fetch(`/app/planner/client/${clientId}/profile/objectives`)
      .then(res => res.json())
      .then(data => {
        const camelData = camelizeKeys(data)
        setForm({
          objectivesAttributes: camelData.objectivesAttributes || [],
        })
      })
  }

  useEffect(() => {
    fetchData()
  }, [clientId])

  const handleSubmit = () => {
    setSaving(true)
    const payload = snakecaseKeys({ client: form })

    fetchWithCsrf(`/app/planner/client/${clientId}/profile/objectives`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) throw new Error()
        return res.json()
      })
      .then(() => {
        addToast({ type: 'success', message: 'Objetivos salvos com sucesso!' })
        fetchData()
        onSuccess()
      })
      .catch(() => {
        addToast({ type: 'error', message: 'Erro ao salvar objetivos.' })
        fetchData()
      })
      .finally(() => setSaving(false))
  }

  return (
    <>
      <form onSubmit={(e) => {
        e.preventDefault()
        handleSubmit()
      }}>
        <div className="bg-white rounded-xl p-6 space-y-8">
          <div>
            <h2 className="text-lg font-semibold text-blueDarker mb-4">Objetivos e Sonhos</h2>
            <ObjectiveFormList
              objectives={form.objectivesAttributes}
              onChange={(updatedList) =>
                setForm(prev => ({ ...prev, objectivesAttributes: updatedList }))
              }
              canWrite={canWrite}
            />
          </div>
        </div>

        {canWrite && (
          <div className="flex justify-end mt-8">
            <Button type="submit" loading={saving}>
              SALVAR E CONTINUAR
            </Button>
          </div>
        )}
      </form>
    </>
  )
}

export default ObjectivesTab
